import React from 'react';
import { ExternalLink, ChevronLeft, ChevronRight  } from 'lucide-react';
import { mockWorks } from '../mock';
import { useRef } from "react";
import './Works.css';

function GetYouTubeId(link) {
  const params = new URL(link).searchParams
  return params.get("v")
}

const YouTubeVideo = (videoId) => {
  return (
    <iframe
      width="560"
      height="315"
      src={`https://www.youtube.com/embed/${videoId}`}
      title="YouTube video player"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    ></iframe>
  )
}

export function scroll(amount) {
    const scrollRef = useRef(null);

  const scroll = (amount) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: amount,
        behavior: "smooth"
      });
    }
  };
}

const GetWorkStatus = (work) => {
  const status = {
    "wip": <span className="work-status-wip">W.I.P</span>,
    "discontinued": <span className="work-status-discontinued">DISCONTINUED</span>,
    "on": <span className="work-status-on">ON</span>
  }

  return status[work.status] || status.on
}

const Works = () => {
  const scrollRef = useRef(null);

  const scroll = (amount) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: amount,
        behavior: "smooth"
      });
    }
  };

  return (
    <section id="works" className="section works-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Projects</h2>
          <p className="section-subtitle">Selected projects I am working on or have worked on.</p>
        </div>
        
        <button id="arrow-right" className="arrow" onClick={() => {scroll(300)}}><ChevronRight/></button>
        <button id="arrow-left" className="arrow" onClick={() => {scroll(-300)}}><ChevronLeft /></button>
        <div className="works-grid" ref={scrollRef}>
          {mockWorks.map((work) => {
            const workStatus = GetWorkStatus(work)
            return (
            <div key={work.id} className="work-card">
              <div className="work-header">
                <div>
                  <h3 className="work-title">{work.title} - {workStatus} </h3>
                  <iframe className='video'
                    width="560"
                    height="315"
                    title='Youtube player'
                    sandbox='allow-same-origin allow-forms allow-popups allow-scripts allow-presentation'
                    src={`https://youtube.com/embed/${GetYouTubeId(work.videourl)}?autoplay=0`}>
                </iframe>
                </div>
                <div className="work-icon">
                  <a 
                    href={work.videourl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="game-link"
                  >
                  <ExternalLink size={20} />
              </a>
                </div>
              </div>
              <p className="work-description">{work.description}</p>
              <div className="work-tech">
                {work.tech.map((tech, index) => (
                  <span key={index} className="tech-tag">{tech}</span>
                ))}
              </div>
              {/*<span className="work-year">{work.year}</span>*/}
            </div>
          )})}
        </div>
      </div>
    </section>
  );
};

export default Works;